import { render, staticRenderFns } from "./SchoolTypeSelect.vue?vue&type=template&id=750c1ef6&"
import script from "./SchoolTypeSelect.vue?vue&type=script&lang=js&"
export * from "./SchoolTypeSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports